import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const DEFAULT_AUTHORIZATION_CODE = '1436';

export function AuthorizationDialog({
  open,
  onOpenChange,
  title = "Authorization Required",
  message = "Enter authorization code to proceed",
  description = null,
  correctCode = DEFAULT_AUTHORIZATION_CODE,
  onAuthorized,
  onCancel,
  promptMessage = null,
  promptValue = '',
  onPromptValueChange = null,
  promptType = 'text'
}) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === correctCode) {
      setCode('');
      setError('');
      if (typeof onAuthorized === 'function') {
        onAuthorized();
      } else {
        console.error('onAuthorized is not a function:', onAuthorized);
        setError('Configuration error - please contact administrator');
      }
    } else {
      setError('Invalid authorization code');
      setCode('');
    }
  };

  const handleClose = () => {
    setCode('');
    setError('');
    if (onCancel) onCancel();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-md bg-white">
        <DialogHeader className="border-b-2 border-black pb-4">
          <DialogTitle className="text-xl font-bold tracking-tight uppercase">{title}</DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="p-4 border-2 border-yellow-500 bg-yellow-50">
            <p className="text-sm font-medium text-yellow-800">{message}</p>
            {description && (
              <p className="text-xs text-yellow-700 mt-2">{description}</p>
            )}
          </div>

          {promptMessage && (
            <div className="space-y-2">
              <Label className="text-xs font-semibold text-gray-700">{promptMessage}</Label>
              <Input
                type={promptType}
                step={promptType === 'number' ? '0.01' : undefined}
                value={promptValue}
                onChange={(e) => onPromptValueChange && onPromptValueChange(e.target.value)}
                placeholder="Enter new value"
                className="text-sm"
              />
            </div>
          )}

          {error && (
            <div className="p-3 bg-red-50 border-2 border-red-500 rounded">
              <p className="text-sm font-semibold text-red-700">{error}</p>
            </div>
          )}

          <div className="space-y-2">
            <Label className="text-xs font-semibold text-gray-500">AUTHORIZATION CODE</Label>
            <Input
              type="password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter code"
              className="text-sm"
              autoFocus={!promptMessage}
            />
          </div>

          <div className="flex gap-3">
            <Button 
              type="button" 
              variant="outline" 
              onClick={handleClose}
              className="flex-1 border-2 border-gray-300"
            >
              Cancel
            </Button>
            <Button 
              type="submit" 
              className="flex-1 bg-black hover:bg-gray-800"
            >
              Authorize
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
